module.exports = __webpack_public_path__ + "img/telling-logo-black.dbdd5e1f.png";